
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "configurePipelinePages",
      resolverType: "mutation",
      routePath: "/configurePipelinePages",
      httpMethod: "POST",
    });
  